import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/_admin/admin/monitoring")({
  validateSearch: z.object({ monitoringRunId: z.string().uuid().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/terminal/admin/runs", search, replace: true })
  },
})
